import { render, staticRenderFns } from "./MainStickyHeader.vue?vue&type=template&id=f8b38548&scoped=true&"
import script from "./MainStickyHeader.vue?vue&type=script&lang=ts&"
export * from "./MainStickyHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MainStickyHeader.vue?vue&type=style&index=0&id=f8b38548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b38548",
  null
  
)

export default component.exports